import ModalPanel from '@admin/components/modal_panel'
import Stack from '@admin/components/stack'
import Downloading from './downloading'
import PropTypes from 'prop-types'
import Browser from './browser'
import Profile from './profile'
import Chooser from './chooser'
import Edit from './edit'
import React from 'react'

class CanvaCover extends React.Component {

  static propTypes = {
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onDone: PropTypes.func
  }

  stackRef = React.createRef()

  _handleBrowser = this._handleBrowser.bind(this)
  _handleChooser = this._handleChooser.bind(this)
  _handleEdit = this._handleEdit.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleDownloading = this._handleDownloading.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Stack { ...this._getStack()} />
      </ModalPanel>
    )
  }

  componentDidMount() {
    this._handleProfile()
  }

  _getPanel() {
    const { onBack, onCancel } = this.props
    return {
      title: 't(Add Cover Photo)',
      leftItems: onBack ? [
        { svg: 'chevron_left', handler: onBack }
      ] : onCancel ? [
        { label: 't(Close)', handler: onCancel }
      ] : []
    }
  }

  _getStack() {
    return {
      display_name: 'canva browser',
      ref: this.stackRef
    }
  }

  _handleClose() {
    this.context.modal.close()
  }

  _handleDone(cover) {
    this.props.onDone(cover)
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handleBrowser(profile) {
    this._handlePush(Browser, {
      profile,
      onDone: this._handleDownloading
    })
  }

  _handleChooser(design) {
    this._handlePush(Chooser, {
      design,
      onDone: this._handleEdit
    })
  }

  _handleDownloading(design) {
    this._handlePush(Downloading, {
      design,
      onDone: this._handleDone
    })
  }

  _handleEdit(design) {
    this._handlePush(Edit, {
      design,
      onDone: this._handleDownloading
    })
  }

  _handleProfile() {
    this._handlePush(Profile, {
      onDone: this._handleChooser
    })
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

}

export default CanvaCover

